<template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout justify-center align-center>
      <v-flex xs12 sm8 md4>
        <material-card
          :color="cardColor"
          title="Safety Database - Login"
          :text="message"
          v-if="!maintenance"
        >
          <v-form ref="form" v-model="validForm">
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="loginForm.username"
                    prepend-icon="mdi-account"
                    name="login"
                    label="Login"
                    type="text"
                    required
                    :rules="validators.username"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="loginForm.password"
                    prepend-icon="mdi-lock"
                    :append-icon="
                      passwordType == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    @click:append="showPwd"
                    name="password"
                    label="Password"
                    id="password"
                    :type="passwordType"
                    required
                    :rules="validators.password"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs6 text-xs-left>
                  <br />
                  <a @click="forgotPass">Forgot password</a>
                </v-flex>

                <v-flex xs6 text-xs-right>
                  <v-btn
                    color="primary"
                    class="mx-0 font-weight-light"
                    @click="login"
                    :disabled="!validForm"
                    >Login</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
        <v-alert
          v-else
          :value="true"
          type="error"
          prominent
          style="text-align: left"
        >
          <h3>{{ maintenance.title }}</h3>
          <div v-html="maintenance.message" />
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import validators from "@/utils/validators";
import { mapState } from "vuex";

export default {
  data: () => ({
    validForm: true,
    validators,
    loginForm: {
      username: "",
      password: "",
    },
    passwordType: "password",
    message: "Please insert your credentials",
    cardColor: "primary",
  }),
  computed: {
    ...mapState("app", ["config"]),
    maintenance() {
      if (this.config.maintenance) {
        return this.config.maintenance.filter((el) => {
          return !el.allowLogin;
        })[0];
      }
      return false;
    },
  },
  mounted() {},
  methods: {
    login(...args) {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$store
        .dispatch("user/login", this.loginForm)
        .then(() => {
          this.cardColor = "success";
          if (this.$route.query.redirect) {
            this.$router.push({ path: this.$route.query.redirect });
          } else {
            this.$router.push({ path: "/" });
          }
          this.loading = false;
          this.loadSponsors();
        })
        .catch((e) => {
          let errorMessage="Authentication failed!";
          if(e.response.status===429){
            errorMessage=e.response.data.message
          }
          this.loading = false;
          this.message = errorMessage;
          this.cardColor = "error";
        });
    },
    forgotPass() {
      this.$router.push({ path: "/forgot-pass" });
    },
    showPwd() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    loadSponsors() {
      this.$store.dispatch("app/loadSponsors").then((sponsors) => {});
    },
  },
};
</script>
